import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContactUs from './Contactus';

const HeroSection = () => {
  const navigate = useNavigate()
  return (
    <section className="hero-section">
      <video autoPlay muted loop className="bg-video">
        <source src="/bro-video-7444b6042fdc6a4cd83dfdc734f364d1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay"></div>
      {/* <div className="zigzag-container">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" className="zigzag">
          <path d="M0,0 C360,100 1080,0 1440,100 L1440,0 L0,0 Z" fill="#d63384"></path>
          <path d="M0,0 C360,100 1080,0 1440,100" stroke="white" strokeWidth="2" fill="none"></path>
        </svg>
      </div> */}
      <div className="hero-content">
        <p className="hero-tagline">DIGITAL TRANSFORMATION PARTNER</p>
        <h1 className="hero-heading">
          Global Expertise, <span className="highlighted">Custom Solutions, </span> Real Results
        </h1>

        <p className="hero-subtext">
            Your trusted partner in delivering innovative and scalable technology solutions that drive growth and accelerate digital transformation.
        </p>
        <div className="hero-cta-buttons">
            <button onClick={() => {navigate('/Contact-us')}}>Talk to Expert →</button>
        </div>
        {/* ISO/GPTW logos */}    
          <div className='hero-section-isoimages'>
           <p className="iso-heading">Certified With :</p>
           <div className="hero-section-imgcontent">
              
              <img src="/iso_footer.png" alt="ISO Certified" />
              <img src="/iso_footer_2.png" alt="ISO Security Certified" />
              <img src="/Gptw.png" alt="Great Place to Work Certified" />
           </div>
           </div>
      </div>
    </section>
  );
};

export default HeroSection;